/** @format */

import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";
import { devise } from "../../utils/utils";
import Ratings from "../Ratings";

const Products = ({ title, products }) => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 2,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  /*
      const products =[
        [1,2,3],
        [4,5,6]
      ] */

  const ButtonGroup = ({ next, previous }) => {
    return (
      <div className='flex justify-between items-center bg-slate-100 px-2 rounded'>
        <div className='text-xl font-mono'>{title}</div>
        <div className='flex justify-center items-center gap-3 text-blue-800'>
          <button
            onClick={() => previous()}
            className='w-[30px] h-[30px] flex justify-center items-center bg-slate-300 border-slate-200'
          >
            <span>
              <FaChevronLeft />
            </span>
          </button>
          <button
            onClick={() => next()}
            className='w-[30px] h-[30px] flex justify-center items-center bg-slate-300 border-slate-200'
          >
            <span>
              <FaChevronRight />
            </span>
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className='flex gap-8 flex-col-reverse'>
      <Carousel
        swipeable={false}
        draggable={false}
        //showDots={true}
        responsive={responsive}
        ssr={true}
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={2200}
        arrows={false}
        keyBoardControl={true}
        //customTransition="all .5"
        transitionDuration={500}
        renderButtonGroupOutside={true}
        customButtonGroup={<ButtonGroup />}
        //containerClass="carousel-container"
        //removeArrowOnDeviceType={["tablet", "mobile"]}
        //deviceType={this.props.deviceType}
      >
        {products.map((p, i) => {
          return (
            <div key={i} className='flex flex-col justify-start gap-2 text-sm'>
              {p.map((product, j) => (
                <Link
                  key={j}
                  className='border block'
                  to={`/product/details/${product._id}`}
                >
                  <div className='relative h-[170px] w-auto items-center justify-center'>
                    <div className='w-full h-full '>
                      <img
                        src={product.images[0].url}
                        alt={`Product ${product.name}`}
                        className='w-auto h-full object-contain'
                      />

                      <div className='absolute h-full w-full top-0 left-0 bg-[#000] opacity-25 hover:opacity-50 transition-all duration-200'></div>
                    </div>
                    {product.discount ? (
                      <div
                        className='flex justify-center items-center absolute text-white w-[38px] h-[38px] rounded-full bg-red-500 
                                        font-semibold text-sm left-2 top-2 '
                      >
                        {product.discount}%
                      </div>
                    ) : null}
                  </div>
                  <div className='p-4 flex flex-col gap-1'>
                    <h2 className=' text-slate-600 font-semibold'>
                      {product.name}
                    </h2>
                    <div className='flex justify-start items-center gap-3'>
                      <h2 className='text-[#2424a8] font-bold'>
                        {product.price} {devise}
                      </h2>
                      <div className='flex'>
                        <Ratings ratings={product.rating} />
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          );
        })}
      </Carousel>
    </div>
  );
};

export default Products;
